export const STORAGE_KEYS = {
  LANGUAGE: "i18nextLng",
  country: "country",
  country_code: "country_code",
  //   CURRENCY: "currency",
};

export const DEFAULT_VALUES = {
  language: "en",
  country: "United Arab Emirates",
  country_code: "AE",
  //   currency: "KWD",
};

export const getUserConfig = () => {
  const rawData = localStorage.getItem("userCurrency");
  let parsedData = null;
  try {
    parsedData = JSON.parse(rawData);
  } catch (e) {
    parsedData = null;
  }

  return {
    language:
      localStorage.getItem(STORAGE_KEYS.LANGUAGE) || DEFAULT_VALUES.language,

    country:
      parsedData?.country ||
      localStorage.getItem(STORAGE_KEYS.country) ||
      DEFAULT_VALUES.country,

    country_code:
      parsedData?.code ||
      localStorage.getItem(STORAGE_KEYS.country_code) ||
      DEFAULT_VALUES.country_code,
    currency: parsedData?.currency || "USD",
  };
};
